/*
 * Scroll reveal + count-up engine.
 * - Elements with [data-reveal] animate in when they enter the viewport.
 *   Variants: default (fade up), "image" (clip-path wipe + scale).
 *   Stagger within a group via the inline --reveal-index custom property.
 * - Elements with [data-count-up="<value>"] count from 0 to the value when
 *   revealed, preserving any prefix/suffix (e.g. "6+", "100s", "1,200").
 * Honors prefers-reduced-motion.
 */
(function () {
  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function countUp(el) {
    var raw = el.getAttribute('data-count-up') || el.textContent;
    var match = raw.match(/^(\D*?)(\d[\d,]*)(.*)$/);
    if (!match) {
      el.textContent = raw;
      return;
    }
    var prefix = match[1] || '';
    var digits = match[2];
    var suffix = match[3] || '';
    var hasComma = digits.indexOf(',') !== -1;
    var target = parseInt(digits.replace(/,/g, ''), 10);

    if (reduce || isNaN(target)) {
      el.textContent = raw;
      return;
    }

    var duration = 1700;
    var startTime = null;

    function format(n) {
      return hasComma ? n.toLocaleString('en-US') : String(n);
    }

    function frame(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var value = Math.round(easeOutCubic(progress) * target);
      el.textContent = prefix + format(value) + suffix;
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = raw; // snap to the exact authored string
      }
    }

    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(frame);
  }

  function activate(el) {
    el.classList.add('is-revealed');
    if (el.hasAttribute('data-count-up')) countUp(el);
    var nested = el.querySelectorAll('[data-count-up]');
    for (var i = 0; i < nested.length; i++) countUp(nested[i]);
  }

  function init() {
    var targets = [].slice.call(document.querySelectorAll('[data-reveal]'));

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(activate);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
